// src/components/Clients.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Container, Typography, Box, Paper, Table, TableBody, TableCell,
    TableHead, TableRow, Button, TextField, Grid, MenuItem,
    IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL || '';

const Clients = () => {
    const [clients, setClients] = useState([]);
    const [form, setForm] = useState({
        company_name: '',
        contact_person: '',
        email: '',
        phone: '',
        service_type: '',
        mrr: '',
        status: '',
        start_date: '',
        next_invoice_date: ''
    });
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    const fetchClients = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/clients`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setClients(response.data);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    useEffect(() => {
        fetchClients();
    }, [token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/clients`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchClients();
            setForm({
                company_name: '', contact_person: '', email: '', phone: '',
                service_type: '', mrr: '', status: '', start_date: '', next_invoice_date: ''
            });
        } catch (error) {
            console.error('Error adding client:', error);
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Klienci</Typography>
                <Paper sx={{ p: 2, mb: 4 }}>
                    <Typography variant="h6">Dodaj nowego klienta</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Nazwa firmy" name="company_name" value={form.company_name} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Osoba kontaktowa" name="contact_person" value={form.contact_person} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Email" name="email" type="email" value={form.email} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Telefon" name="phone" value={form.phone} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select fullWidth label="Typ usługi" name="service_type" value={form.service_type} onChange={handleChange} required
                                >
                                    <MenuItem value="aiteams">aiteams</MenuItem>
                                    <MenuItem value="pricemonit">pricemonit</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="MRR" name="mrr" value={form.mrr} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select fullWidth label="Status" name="status" value={form.status} onChange={handleChange} required
                                >
                                    <MenuItem value="active">active</MenuItem>
                                    <MenuItem value="pending">pending</MenuItem>
                                    <MenuItem value="inactive">inactive</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Data rozpoczęcia" name="start_date" type="date" value={form.start_date} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Data następnej faktury" name="next_invoice_date" type="date" value={form.next_invoice_date} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">Dodaj klienta</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper sx={{ p: 2, width: '100%', overflowX: 'auto' }}>
                    <Box sx={{ minWidth: 800 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nazwa firmy</TableCell>
                                    <TableCell>Osoba kontaktowa</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Telefon</TableCell>
                                    <TableCell>Typ usługi</TableCell>
                                    <TableCell>MRR</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Data rozpoczęcia</TableCell>
                                    <TableCell>Akcje</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {clients.map(client => (
                                    <TableRow key={client.id}>
                                        <TableCell>{client.company_name}</TableCell>
                                        <TableCell>{client.contact_person}</TableCell>
                                        <TableCell>{client.email}</TableCell>
                                        <TableCell>{client.phone}</TableCell>
                                        <TableCell>{client.service_type}</TableCell>
                                        <TableCell>{client.mrr}</TableCell>
                                        <TableCell>{client.status}</TableCell>
                                        <TableCell>{client.start_date}</TableCell>
                                        <TableCell>
                                            <IconButton color="primary" onClick={() => navigate(`/clients/edit/${client.id}`)}>
                                                <EditIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default Clients;